#@import Booking.Views.Base
#@import Booking.Presenters.Base
#@export Booking.Views.Tooltip

class Booking.Views.Tooltip extends Booking.Views.Base

  presenter: Booking.Presenters.Base

  templateName: 'tooltip'

  className: 'ob-tooltip'

  events:
    'click': 'close'

  open: ($target, targetType) ->
    @setPosition($target, targetType)
    @$el.show()

  close: ->
    @$el.remove()

  setPosition: ($target, targetType) ->
    {top} = $target.position()
    type = @getTypeOfTooltip(top)
    isDefaultType = type is 'default'

    # DEFAULT_VERTICALOFFSET_BUBBLE = 42
    # DEFAULT_VERTICALOFFSET_DAY = 12
    # targetType is 'day' or 'bubble' based on where the tooltip is targetted
    DEFAULT_VERTICALOFFSET = if targetType is 'day' then 12 else 42
    TOP_ARROW_VERTICALOFFSET = 11

    @setArrowPosition($target, type)
    padding = if isDefaultType then -@$el.height() - DEFAULT_VERTICALOFFSET else $target.height() + TOP_ARROW_VERTICALOFFSET
    top = top + padding
    @$el.css('top', top)

  setArrowPosition: ($target, type) ->
    position = $target.position()
    width = $target.width()
    @$el.find('.arrow').css 'left', position.left + width / 2
    @$el.addClass(type)

  getTypeOfTooltip: (top) ->
    switch
      when top < 123
        type = 'top-arrow'
      else
        type = 'default'
